//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import * as axios from "@/store/http";
import formValidate from "@/js/formValidate";
import stepsFlow from "@/pcpage/process/stepsFlow";
// import { Loading } from 'element-ui';

//彈出新窗口
Vue.prototype.openWinScroll = function(url, query) {
    let portalflag = this.$route.query.portalflag;
    let sysflag = this.$route.query.sysflag;
    if(portalflag == 'portal'){
        if(url.indexOf("?") > -1){
            url = url + "&portalflag="+portalflag;
        }else{
            url = url + "?portalflag="+portalflag;
        }
    }
    if(sysflag == 'ft'){
        if(url.indexOf("?") > -1){
            url = url + "&sysflag="+sysflag;
        }else{
            url = url + "?sysflag="+sysflag;
        }
    }
    let routeUrl = this.$router.resolve({
        path: url,
        query: query
    });
    let h = window.screen.availHeight;
    let w = window.screen.availWidth;

    let pos =
        "width=" +
        (w-20) +
        ",height=" +
        (h-50) +
        ",top=0,left=0,toolbar=no,menubar=no,scrollbars=1, resizable=no,location=no, status=no";

    // let pos =
    // "fullscreen,resizable=yes,toolbar=no";
    window.open(routeUrl.href, "_blank", pos);
}

// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading1;
function startLoading(vtext) {

  loading1 = Vue.prototype.$loading({
    lock: true,
    text: vtext,
    background: "rgba(0, 0, 0, 0.5)",
    spinner: 'icon-loading',
    target: document.querySelector('body')//设置加载动画区域
  });

}
function endLoading() {
  loading1.close();
}

//es6方式，返回布尔值
const isType = type => obj => Object.prototype.toString.call(obj) === `[object ${type}]`;
const isArray = isType('Array');// 注意首字母大写

export default {
    // inject:['reload'],
     name: "detailFlow",

     components: {
      "steps-flow": stepsFlow
     },
     //控件属性
     props:{
        saveaction:{type:String,require: true},
        deleteaction:{type:String,require: true},
        parentpath:{type:String,require: true},
        operationList: {type:Array,require: true},
        beforesubmit:{type:Function,require: false},
        beforesave:{type:Function,require: false},
        record:{type:Object,require: true}, //业务数据
        process:{type:Object,require: true}, //流程数据
        rulesList:{type:Object},
        flowrules:{type:Object},
        billrules:{type:Object},
        formname :{type:String,require: true},
        reloadbill:{type:Function,require: true},
        formTipArray:{type:Array,require: true},
        validFormInfo: {
            type: Object,
            default: () => ({})
        },
        beforedelete:{type:Function,require: false},
        afterdelete:{type:Function,require: false},
        keyname:{type:String,require: false,default : "billid"},

        //用于beforesubmit为false时不关闭提交框
        //默认为true无影响，设为false时将静止提交框关闭
        ifclosetip:{type:Boolean,default: true}

     },
     data(){
        return {
            sendemailon: "",
            sendemailToCCon: "",
            sendemail: "",
            sendemailToCC: "",
            sendsmson:"",
            sendsms: "",
            maxLength: 20,
            loading: false,
            isDisabled: false,
            sconareacode: '',
            activeName: 'first',
            s_advice:"",//下拉框意见
            t_advice:"", //文本框意见
            nextstatus:"", //下一步骤
            nextpathtype:"", //下一步骤路由类型
            filtertype:"", //下一步骤剔除类型
            transferflag:"", //下一步驟转交类型
            nextuser :"",//下一办理人
            reader: "", // 阅办人员
            readername: "", //阅办人员显示名称
            readershow: 0,// 传阅人员是否显示，0:不显示;1:显示
            nextusers :[],//下一办理人
            nextusernames: '',//下一办理人（弹窗）
            choosetype: "", //办理人选择类型
            trantype: "", //办理人类型
            answerList : [], //意见列表
            nextstatusList :[], //下一步骤列表
            nextuserList:[], //下一办理人列表
            returnflag :true,
            dialogProcessVisible:false,//流程帧是否显示,
            dialogVisible:false, //消息框是否显示
            dialogBflowVisible:false,//办理意见是否显示
            dialogPredictionVisible: false,//流程预判是否显示s
            dialogsetflowVisible: false, //设置流程是否显示
            dialogReadFormVisible: false,// 阅办意见是否显示
            dialogCopyReadFormVisible: false, //传阅抄送是否显示
            bflowList:[],//办理意见列表
            currflowlist: [], //当前办理步骤列表,
            cflowlist: [], //流程节点列表
            tipmsg:"",
            formsize:'',
            count:"",
            adviceDispSort:1,
            params :{}, //业务单据保存回来后的参数

            portalflag:'',
            btnsLength: 4, //按钮展示个数，超出点击省略号展示
            uniflowmonitorurl: '', // 流程跟踪url
            monitorActiveName: '' ,// 流程跟踪折叠面板是否打开
            reloadflag : "1",//页面重载标识 默认1 保存前设置成0
            setflowform:{} , //设置流程对象
            readForm:{},
            //是否隐藏id，true为显示
            hideId:false,
            rules: {} //流程校验规则

        }
     },
     methods:{
         maxSlice (v) {
           return v.length > this.maxLength ? v.slice(0, this.maxLength) + '...':v ;
         },
         //流程按钮总的入口，根据type来区分不通的按钮
         mainsubmit(type){
             //打开流程框
             if(type == 'submit'){
                this.openProcess();
             }
             // 打开阅办
             if(type==='read'){
               this.openReadAdvice();
             }

             // 打开阅办
             if(type==='copyread'){
               this.openCopyReadAdvice();
             }

             // 回收
             if(type == 'reclaim'){
                 this.reclaim();
             }
             //保存业务单据
             if(type == 'save'){
                 this.savebill();
             }
             //删除业务单据
             if(type == 'delete'){
                 this.deletebill();
             }
             //打开办理过程框
             if(type == 'getFlowAdvice'){
                this.openBflowAdvice();
             }
             // 设置流程对话框
             if (type == 'setflow') {
                // console.log(this.process.flow_applyareacode);
                this.sconareacode = this.process.flow_applyareacode;
                this.opensetflowAdvice();
             }
             // 打开流程预判窗口
             if (type === 'prediction'){
                // let vPiid = this.process.processid;
                // let vKeyval = this.process.flow_keyval;
                // let vBtype = this.process.flow_btype;
                // let record = JSON.stringify(this.record);
                // vPiid="piid:53ef3dbdff1a4e1db71e9616f485cfc3";
                // let oQuery = {'piid':vPiid,'flow_keyval':vKeyval,'flow_btype':vBtype};
                // // oQuery[this.keyname] = row[this.keyname];
                // let path ="/stepsFlow";
                // this.openWinScroll(path,oQuery);

                this.openPrediction();


             }
         },
         //关闭窗口清空业务数据
         closeDialog(){
             //刷新父页面
             // window.opener.postMessage('','*');
             // window.parent.gofather();
             //this.reload();
             //this.$parent.$parent.gofather();
             this.dialogProcessVisible =false;
             this.nextstatus = "";
             this.reader = "";
             this.readername = "";
             this.nextpathtype="";
             this.filtertype = "";
             this.transferflag="";
             this.cflowlist = [];
             this.currflowlist = [];
             this.nextstatusList = [];
             this.nextuserList = [];
             this.s_advice = "";
             this.t_advice = "";
             this.dialogBflowVisible = false;
             this.dialogPredictionVisible = false;
             this.dialogsetflowVisible = false;
             this.dialogReadFormVisible = false;
             this.dialogCopyReadFormVisible = false;
             this.monitorActiveName = "";
             this.isDisabled = false;
             this.sendemailon="";
             this.sendemailToCCon="";
             this.sendemail="";
             this.sendemailToCC = "";
             this.sendsms="";
             this.sendsmson="";
         },

        openModel(modelName) {
            //  设置弹框居中
            this.setDialogPos(modelName);
        },

         //改变意见下拉框的值
         changeAdvice(){
           for(let i = 0 ; i < this.answerList.length;i++){
               var obj = this.answerList[i];
               var value = obj.value;
               var label = obj.text;
               if(value != "" && value === this.s_advice){
                  this.$nextTick(() => {
                    this.t_advice = label;
                  });
                  break;
               }
           }
         },
        /**
         * 添加常用意见
         */
         async addAdvice(){
             // console.log(this.answerList.length);
             if(this.t_advice.length>2000){
               this.$message({
                        showClose: true,
                        message: this.$t('flow_process.advicelengthwarn'),
                        type: 'warning'
                      });

                return false;
             }
             this.adviceDispSort = this.answerList.length;

             let params= {
                 act :"add",
                 answer:this.t_advice,
                 flow_keyval: this.process.flow_keyval,
                 flow_btype: this.process.flow_btype,
                 dispsort: this.adviceDispSort
             }
            // console.log(params);
            await axios.post('/flowProcess/dealAdvice',params).then(({data})=>{
               var code = data.code;
                if(code != '1'){
                   //返回失败
                    this.tipSuccess(this.$t("flow_process.saveerror"));
                }else{
                    this.tipSuccess(this.$t("flow_process.savesuccess"));
                    this.answerList = data.data.answerList;
                }
            });

         },
         async delAdvice(answerid){
            // console.log('answer===',answerid);
            let params= {
                act :"del",
                ids:answerid,
                flow_keyval: this.process.flow_keyval,
                flow_btype: this.process.flow_btype
            }
           await axios.post('/flowProcess/dealAdvice',params).then(({data})=>{
              var code = data.code;
               if(code != '1'){
                  //返回失败
                   this.tipSuccess(this.$t("flow_process.deladviceerror"));
               }else{
                   this.tipSuccess(this.$t("flow_process.deladvicesucc"));
                   this.answerList = data.data.answerList;
               }
           });
           this.s_advice = '';
           this.t_advice = '';

         },
         getparent(){
             console.info("getparent");
         },

         //调用父页面的方法
         lalClickEvent(){
            this.$emit("getparentDate");
         },
        /**
         * 打开流程帧方法，每次都重新加载下流程信息
         */
        async  openProcess(){
            this.isDisabled = false;
            //打开弹出框之前先保存业务单据
            var flag = false;
              //保存业务数据
            let params = {
                act : "save",
                record : this.record,
                process: this.process
             };
            try {
                if(!await this.beforesave()){
                    return;
                }
            } catch (error) {}

            let flowstate = this.process.flowstate;
            let operType = "save";
            if(flowstate == 0){
              // 流程起始步骤的节点，点submit的按钮的时候必填控制方式调整
              operType = "submit";
              try{
                if(!await this.beforesubmit()){
                    return;
                }
              } catch (error) {}
            }
            await formValidate.bindRules4Flow(this.$parent, operType);
            await formValidate.clearFormValidateTip(this.$parent);
            this.formTipArray.length = 0;

            this.$nextTick(() => {
                Promise.all(this.buildForms())
                .then(async () => {
                   //保存前校验单据是否加载成功
                  if(!this.checkBillReload()){
                    return;
                  }
                   await axios.post(this.saveaction,params).then(({data})=>{
                       var code = data.code;
                        if(code != '1'){
                           //返回失败
                           flag = false;
                        }else{
                           flag = true;
                        }
                    });

                    if(flag){
                        this.reloadbill();
                        this.reloadflag = "1";
                        this.dialogProcessVisible = true;
                            //如果ID为空，则就先保存单据后，在弹出提交框
                            let params = {
                                record : this.record,
                                process: this.process
                            };
                            //获取后端数据
                          await axios.post("flowProcess/load",params).then(({data})=>{
                            var code = data.code;
                            if(code != '1'){
                                //返回失败
                                this.returnflag = false;
                            }else{
                                //绑定数据到model
                                this.reader = data.data.process.defaultReader.reader;
                                this.readername = data.data.process.defaultReader.readername;
                                this.sendemailon = data.data.process.sendemailon;
                                this.sendemailToCCon = data.data.process.sendemailToCCon;
                                this.sendsmson = data.data.process.sendsmson;

                                if(this.reader != '')
                                {
                                  this.readershow=1;
                                }
                                this.answerList = data.data.answerList;
                                this.nextstatusList = data.data.nextstatusList;
                                //获取默认选中的人员
                                // console.info(JSON.stringify(this.nextstatusList));
                                //获取默认下一步骤
                                    for(let nextstatus of this.nextstatusList) {
                                      let checkflag = nextstatus.checkflag;
                                      if(checkflag == '1'){
                                          this.nextstatus =nextstatus.value;
                                          let notnullitems = nextstatus.notnullitems;
                                          this.nextpathtype = nextstatus.pathtype;
                                          this.filtertype = nextstatus.filtertype;
                                          this.transferflag = nextstatus.transferflag;
                                          if(Object.keys(notnullitems).length>0 ){
                                            let notnullitemsStr = this.process.orinotnullitems;
                                            for(let notnullitem of notnullitems){
                                               let fieldId = notnullitem.ELMT_ID;
                                               let fieldName = notnullitem.ELMT_NAME;
                                               if(notnullitemsStr.indexOf(';'+fieldId+'|'+fieldName+';')==-1){
                                                notnullitemsStr += fieldId+"|"+fieldName+";";
                                               }
                                            }
                                            this.$nextTick(() => {
                                              this.process.notnullitems=notnullitemsStr;
                                            });
                                          }

                                          break;
                                      }

                                      }

                                    // }
                                    //下一办理人选择方式可能有多种，目前只在做单选下一办理人
                                    //获取默认下一办理人
                                this.setNextUserList(data);
                                if(this.t_advice===''){
                                  if(this.nextpathtype==='2'){
                                    this.t_advice = this.$t('flow_process.defaultadvice_disagree');
                                  }else{
                                    this.t_advice = this.$t('flow_process.defaultadvice_agree');
                                  }
                                }
                            }
                            this.loading = false;
                            });
                    }else{
                       //保存失败直接弹出提示
                       this.tipError(this.$t('flow_process.saveerror'));
                    }
                    this.loading = false;
                })
                .catch(error => {
                    if (this.formTipArray.length > 0) {
                        let oFormValidateTip = this.formErrorTip2(
                            this.$t("flow_process.msgtitle"),
                            this.formTipArray
                        );
                        formValidate.pushFormValidateTip(this.$parent, oFormValidateTip);
                    } else {
                        this.tipError(this.$t("flow_process.saveerror2"));
                    }
                });
            });
         },
        /**
         * 保存前校验单据是否加载成功
         */
         checkBillReload(){
           let bflag = true;
           if(this.reloadflag){
               //将加载标识重置成0
               this.reloadflag = 0;
            }else{
              this.$message({
                type: "error",
                message: this.$t("flow_process.billreloaderror")
              });
              bflag = false;
            }
            return bflag;
        },

        /**
         * 打开办理过程
         */
        openBflowAdvice() {
            this.uniflowmonitorurl = this.process.uniflowmonitorurl+"?piid="+this.process.processid+"&tenantCode="+this.process.tenantcode;
            let params = {process: this.process};
            //获取后端数据
            axios.post("flowProcess/loadBflowList", params).then(({data}) => {
                console.log(data);
                var code = data.code;
                if(code != '1') {
                    //返回失败
                    this.returnflag = false;
                } else {
                    //绑定数据到model
                    this.bflowList = data.data.bflowList;
                }
                this.loading = false;
            });
            this.dialogBflowVisible = true;
            this.dialogsetflowVisible = false;
        },
        // 打开流程预判界面
        openPrediction() {
            this.dialogPredictionVisible = true;
        },
        /**
         * 打开流程设置界面
         */
        opensetflowAdvice() {
          let params = { process: this.process };
          //获取后端数据
          axios.post('flowProcess/loadSetFlow', params).then(({ data }) => {
            // console.log(data);
            var code = data.code;
            if (code != '1') {
              //返回失败
              this.returnflag = false;
            } else {
              //绑定数据到model
              this.currflowlist = data.data.currflowlist;
              this.cflowlist = data.data.cflowlist;
              // console.log('========================');
              // console.log(this.currflowlist);
            }
            this.loading = false;
          });
          this.dialogsetflowVisible = true;
        },

        /**
         * 打开阅办办理界面
         */
        openReadAdvice() {
          this.loading = false;
          this.dialogReadFormVisible = true;
        },

        /**
         * 打开抄送传阅界面
         */
        openCopyReadAdvice() {
          this.loading = false;
          this.dialogCopyReadFormVisible = true;
        },
        printPage(){

          let vPiid = this.process.processid;
          let vKeyval = this.process.flow_keyval;
          let vBtype = this.process.flow_btype;
          let oQuery = {'piid':vPiid,'flow_keyval':vKeyval,'flow_btype':vBtype,"monitorurl":this.uniflowmonitorurl};
          // oQuery[this.keyname] = row[this.keyname];
          let path ="/printBflowList";
          this.openWinScroll(path,oQuery);

        },
        indexMethod(index) {
        //序号
            return index + 1;
        },

         /**
          * 保存业务单据
          */
         async savebill(){
           // let loadingInstance = Loading.service({ fullscreen: true });
            //保存业务数据

            let params = {
                act : "save",
                record : this.record,
                process: this.process
             };
            try {
                if(!await this.beforesave()){
                    return;
                }
            } catch (error) {}

            await formValidate.bindRules4Flow(this.$parent,'save');
            await formValidate.clearFormValidateTip(this.$parent);
            this.formTipArray.length=0;

            this.$nextTick(() => {
                Promise.all(this.buildForms())
                .then(() => {
                    //保存前校验单据是否加载成功
                    if(!this.checkBillReload()){
                      return;
                    }
                    axios.post(this.saveaction, params).then(({ data }) => {
                    var code = data.code;
                    console.info(code);
                    if (code != "1") {
                        // loadingInstance.close();
                        //返回失败
                        this.returnflag = false;
                    } else {
                        //  loadingInstance.close();
                        // this.dialogVisible= true;
                        this.params = data.data.params;
                        //重新设置record的主键的值
                        this.$router.push({
                        path: this.parentpath,
                        query: this.params
                        });
                        //动态设置服务端返回来的参数值
                        var returnParams = this.params;
                        for (var key in returnParams) {
                        //遍历json对象的每个key/value对,p为key
                        console.info(key + " " + returnParams[key]);
                        this.record[key] = returnParams[key];
                        }
                        //弹出提示框 进行倒计时
                        this.tipSuccess(this.$t("flow_process.savesuccess"));
                        this.reloadbill();
                        this.reloadflag = "1";
                        if(this.portalflag !='portal'){
                            //刷新父窗口
                            window.opener.location.reload();
                        }

                    }
                    });
                })
                .catch(error => {
                    if(this.formTipArray.length > 0){
                        let oFormValidateTip = this.formErrorTip2(
                        this.$t("flow_process.msgtitle"),
                        this.formTipArray
                        );
                        formValidate.pushFormValidateTip(this.$parent, oFormValidateTip);
                    }else{
                        this.tipError(this.$t("flow_process.saveerror2"));
                    }
                });
            });
         },
         async reclaim(){
            this.tipCustomConfirm("default", this.$t("flow_process.confirmReclaim"), "")
            .then(() => {
                this.$nextTick(() => {
                    Promise.all(this.buildForms())
                    .then(async () => {
                        let params = {
                        act: "reclaim",
                        flow_nextstatus: '', //下一步骤
                        flow_advice: this.t_advice, //办理意见
                        flow_nextuser: '', //下一办理人
                        flow_currreader: "", //阅办人员
                        record: this.record,
                        process: this.process
                        };
                        //进行提交操作
                        await axios.post(this.saveaction, params).then(({ data }) => {
                        var code = data.code;

                        if (code != "1") {
                            //返回失败
                            this.returnflag = false;
                        } else {
                            this.dialogVisible = true;
                            this.params = data.data.params;
                            //弹出提示框 进行倒计时
                            this.threeGo();
                        }
                        });
                        //刷新父窗口
                        if(this.portalflag !='portal'){
                            window.location.reload();
                        }

                    })
                    .catch(() => {
                        this.tipError(this.$t("flow_process.saveerror2"));
                    });
                });
            })
            // this.$confirm(this.$t("flow_process.confirmReclaim"),this.$t("flow_process.title"),{
            //     confirmButtonText:this.$t("flow_process.confirm"),
            //     cancelButtonText:this.$t("flow_process.changle")
            // }).then(()=>{
            //     this.$nextTick(() => {
            //     Promise.all(this.buildForms())
            //     .then(async () => {
            //         let params = {
            //         act: "reclaim",
            //         flow_nextstatus: '', //下一步骤
            //         flow_advice: this.t_advice, //办理意见
            //         flow_nextuser: '', //下一办理人
            //         flow_currreader: "", //阅办人员
            //         record: this.record,
            //         process: this.process
            //         };
            //         //进行提交操作
            //         await axios.post(this.saveaction, params).then(({ data }) => {
            //         var code = data.code;

            //         if (code != "1") {
            //             //返回失败
            //             this.returnflag = false;
            //         } else {
            //             this.dialogVisible = true;
            //             this.params = data.data.params;
            //             //弹出提示框 进行倒计时
            //             this.threeGo();
            //         }
            //         });
            //         //刷新父窗口
            //         window.location.reload();

            //     })
            //     .catch(() => {
            //         this.tipError(this.$t("flow_process.saveerror2"));
            //     });
            // });

            // }).catch(()=>{

            // });

         },
         checkFormElment(vElement,vMsg){
            let breturn = true;
            if(vElement==''){
                this.$message.error(vMsg);
                this.isDisabled = false;
                endLoading();
                breturn=false;
            }

            return breturn;

         },
         /**
         * 格式化消息
         * @param {*} source
         * @param {*} params
         * @returns
         */
        formatMsg(source, params) {
            if (!params) {
                return '';
            }

            if (params.constructor !== Array) {
                params = [params];
            }

            for (let i = 0; i < params.length; i++) {
                source = source.replace(new RegExp("\\{" + i + "\\}", "g"), params[i])
            }

            return source;
        },
        /**
         * 提交阅办意见
         */
        async finishRead(){
            startLoading(this.$t('flow_process.submitting'));
            this.isDisabled = true;
            let readFlowName = '';
            let params = {
              flow_keyval: this.process.flow_keyval,
              flow_btype: this.process.flow_btype
            };
            await axios.post('/flowProcess/getCurrReadFlowName',params).then(({data})=>{
               var code = data.code;
                if(code === '1'){
                   readFlowName = data.data.readflowname;
                }else{
                  this.isDisabled = false;
                  endLoading();
                }
            });
            this.$nextTick(() => {
                Promise.all(this.buildForms())
                .then(async () => {
                    let params = {
                    act: "finishread",
                    flow_advice: this.t_advice, //办理意见
                    flow_currreadstatus: readFlowName,
                    record: this.record,
                    process: this.process
                    };
                    //进行提交操作
                    // console.info(params);
                    await axios.post(this.saveaction, params).then(({ data }) => {
                    var code = data.code;
                    console.info("=========" + JSON.stringify(data));
                    // console.info(code);
                    if (code != "1") {
                        //返回失败
                        this.returnflag = false;
                    } else {
                        this.dialogVisible = true;
                        this.params = data.data.params;

                        // let successMsg='';
                        // successMsg=this.$t('flow_process.successtip1')+this.count+this.$t('flow_process.successtip2')+this.$t('flow_process.savesuccess')
                        // this.tipAlert('提示',successMsg,'确定')
                        //弹出提示框 进行倒计时
                        this.threeGo();
                    }
                    });

                    this.isDisabled = false;
                    endLoading();

                    //关闭流程帧
                    this.dialogReadFormVisible = false;

                    if(this.portalflag !='portal'){
                        //刷新父窗口
                        window.opener.location.reload();
                    }

                })
                .catch(error => {

                    console.log("error",error);
                    this.isDisabled = false;
                    endLoading();

                });
            });
            // this.isDisabled = false;
            // endLoading();
        },

        async copyRead(){
            startLoading(this.$t('flow_process.submitting'));
            this.isDisabled = true;

            this.$nextTick(() => {
                Promise.all(this.buildForms())
                .then(async () => {
                    let params = {
                    flow_advice: this.t_advice, //办理意见
                    flow_reader: this.reader, //阅办人员
                    record: this.record,
                    process: this.process
                    };
                    //进行提交操作
                    // console.info(params);
                    await axios.post('/flowProcess/createReads', params).then(({ data }) => {
                    var code = data.code;
                    console.info("=========" + JSON.stringify(data));
                    // console.info(code);
                    if (code != "1") {
                        //返回失败
                        this.returnflag = false;
                    } else {
                        this.dialogVisible = true;
                        this.params = data.data.params;

                        this.threeGo();
                    }
                    });

                    this.isDisabled = false;
                    endLoading();

                    //关闭流程帧
                    this.dialogReadFormVisible = false;

                    if(this.portalflag !='portal'){
                        //刷新父窗口
                        window.opener.location.reload();
                    }

                })
                .catch(error => {

                    console.log("error",error);
                    this.isDisabled = false;
                    endLoading();

                });
            });
        },

         /**
          * 提交业务单据
          */
         async confireSubmit(){
            startLoading(this.$t('flow_process.submitting'));
            this.isDisabled = true;
            // console.log(this.nextusers.length);
            if(this.choosetype==='2'){
              if(isArray(this.nextusers)){
                this.nextuser = this.nextusers.join(';');
              }else{
                this.nextuser = this.nextusers;
              }
            }else if(this.choosetype==='3'){
                this.nextuser = this.nextusers;
            }

            let elemName = this.$t('flow_process.nextstatus');
              if(!this.checkFormElment(this.nextstatus,this.formatMsg(this.$t('flow_process.errormsg'), [elemName]))){
                this.isDisabled = false;
                endLoading();
                return false;
            }
            if(this.nextstatus.split("#").length==4){
                elemName = this.$t('flow_process.nextuser');
                if(this.nextstatus.split("#")[3]!='2' && !this.checkFormElment(this.nextuser,this.formatMsg(this.$t('flow_process.errormsg'), [elemName]))){
                    this.isDisabled = false;
                    endLoading();
                    return false;
                }
            }
            if(!this.checkAdvice()){
                this.isDisabled = false;
                endLoading();
                return false;
            }
            if(this.nextpathtype !='2'
            && this.nextstatus.split("#")[0] != 'NO'
            && this.nextstatus.split("#")[0] != 'back'
            && this.nextstatus.split("#")[0] != 'transfer'){
              try {
                  if(!await this.beforesubmit()){
                      if(this.ifclosetip){
                        this.dialogProcessVisible = false;
                      }else{
                        this.isDisabled = false;
                      }

                      endLoading();
                      return;
                  }

                  let params1 = {
                  flow_keyval: this.process.flow_keyval,
                  flow_btype: this.process.flow_btype,
                  flow_curruserid: this.process.flow_curruserid,
                  flow_currdeptid: this.process.flow_currdeptid,
                  flow_currstatus: this.process.flow_currstatus,
                  applyareacode: this.process.applyareacode
                  };
                  // let passFlag = true;
                  // await axios.post('/flowProcess/checkSubmitNextFlag',params1).then(({data})=>{
                  //    var code = data.code;
                  //     if(code == '1'){
                  //        passFlag = data.data.data.passflag;
                  //        if(passFlag==false){
                  //          this.isDisabled = false;
                  //          endLoading();
                  //          var errMsg = data.data.data.reason;
                  //          this.$message({
                  //                   showClose: true,
                  //                   message: errMsg,
                  //                   type: 'warning'
                  //                 });

                  //           return false;
                  //         }
                  //     }
                  // });
                  let res = await this.checkSubmitNextFlag(params1);
                  let code1 = res.data.code;
                  if(code1=='1'){

                      let passFlag = res.data.data.data.passflag;
                      if(passFlag==false){
                         this.isDisabled = false;
                         endLoading();
                         let errMsg = res.data.data.data.reason;
                         this.$message({
                                  showClose: true,
                                  message: errMsg,
                                  type: 'warning'
                                });

                          return false;
                      }
                  }

              } catch (error) {}

              await formValidate.bindRules4Flow(this.$parent,'submit');
              await formValidate.clearFormValidateTip(this.$parent);
            }else{
               this.$nextTick(() => {
                 this.process.notnullitems='';
               });
            }

            //提示首先置为空
            this.formTipArray.length=0
            this.$nextTick(() => {
                Promise.all(this.buildForms())
                .then(async () => {
                    let params = {
                    act: "submit",
                    flow_nextstatus: this.nextstatus, //下一步骤
                    flow_nextpathtype: this.nextpathtype, // 下一步骤路径类型
                    flow_advice: this.t_advice, //办理意见
                    flow_nextuser: this.nextuser, //下一办理人
                    flow_reader: this.reader, //阅办人员
                    flow_sendemail: this.sendemail,
                    flow_sendemailToCC: this.sendemailToCC,
                    flow_sendsms: this.sendsms,
                    record: this.record,
                    process: this.process
                    };
                    //进行提交操作
                    console.info(params);
                    await axios.post(this.saveaction, params).then(({ data }) => {
                    var code = data.code;
                    console.info("=========" + JSON.stringify(data));
                    console.info(code);
                    if (code != "1") {
                        //返回失败
                        this.returnflag = false;

                    } else {
                        this.dialogVisible = true;
                        this.params = data.data.params;

                        // let successMsg='';
                        // successMsg=this.$t('flow_process.successtip1')+this.count+this.$t('flow_process.successtip2')+this.$t('flow_process.savesuccess')
                        // this.tipAlert('提示',successMsg,'确定')
                        //弹出提示框 进行倒计时
                        this.threeGo();
                    }
                    });

                    this.isDisabled = false;
                    endLoading();

                    //关闭流程帧
                    this.dialogProcessVisible = false;

                    if(this.portalflag !='portal'){
                        //刷新父窗口
                        window.opener.location.reload();
                    }

                    // this.loading = false;
                    // this.dialogVisible= true;
                    // this.tipAlert('提示','信息内容','确定')

                    //  this.threeGo();
                    // //先保存父方法，在提交
                    // this.lalClickEvent();
                    // var aaa = this.validateMethod();
                    // console.info(aaa);
                    //关闭
                    // this.dialogTableVisible =false;
                    // console.info( this.form.resource);
                })
                .catch(error => {

                    console.log("error",error);
                    this.isDisabled = false;
                    endLoading();

                    if(this.formTipArray.length > 0){
                        this.dialogProcessVisible = false;
                        //必填域错误提示
                        let oFormValidateTip = this.formErrorTip2(
                        this.$t("flow_process.msgtitle"),
                        this.formTipArray
                        );
                        formValidate.pushFormValidateTip(this.$parent, oFormValidateTip);
                        //关闭对话框。清空数据
                        this.closeDialog();
                    }else{
                        if(error.data.msg==""||error.data.msg==null||error.data.msg==undefined)
                        {
                            this.tipError(this.$t("flow_process.saveerror2"));
                        }
                        // console.log('2020年07月03日15:59:22 detailFlow.vue[xxxx]——[null] :',null);
                        this.dialogProcessVisible = false;
                    }
                });
            });
            // this.isDisabled = false;
            // endLoading();

         },
         checkSubmitNextFlag(vparams){
             return new Promise((resolve, reject) => {
                axios.post('/flowProcess/checkSubmitNextFlag', vparams).then((res) => {
                  resolve(res)
                }).catch((err) => {
                  reject(err)
                })
              })
         },
         //公用单据删除方法
        async deletebill () {

            let oQuery = {};
            let deleteflag = true;

            oQuery.delBillids = this.record[this.keyname];

            try {
                deleteflag = this.beforedelete(oQuery);
            } catch (error) {
                deleteflag = true;
            }
            if(deleteflag){
              this.tipCustomConfirm("default", this.$t('flow_process.deletemsg'), "").then (() => {
                    this.axios.post(this.deleteaction, oQuery).then(({ data }) => {
                        if (data.code == "1") {
                            let closeFlag=true;
                            try {
                                closeFlag=this.afterdelete(oQuery,data);
                            } catch (error) {}
                            //刷新父窗口
                            if(closeFlag){
                                if(this.portalflag !='portal'){
                                    window.opener.location.reload();
                                }
                                //关闭窗口
                                window.close();
                            }
                        } else {
                            console.log("flow_process.deletebill : " , data.msg);
                        }
                    });
                });
            }
        },
        /**
         * 调整流程步骤，获取下一办理人和必填项
         */
        async changestatus(item,index){
            this.nextpathtype = item.pathtype;
            this.transferflag = item.transferflag;
            // console.log('this.nextpathtype===',this.nextpathtype);
            let params = {
                record : this.record,
                process: this.process
             };
             params.process.flow_nextstatus = this.nextstatus;
             // 下一步骤路径类型
             params.process.flow_nextpathtype = this.nextpathtype;

             params.process.transferflag = this.transferflag;
             params.process.filtertype = this.filtertype;
             await axios.post("/flowProcess/changeStatus",params).then(({data})=>{
               var code = data.code;
               console.info(code);
                if(code != '1'){
                   //返回失败
                   this.returnflag = false;
                }else{

                  let notnullitems = item.notnullitems;
                  // console.log('notnullitems===',notnullitems);
                  if(Object.keys(notnullitems).length>0 ){
                    let notnullitemsStr = this.process.orinotnullitems;
                    for(let notnullitem of notnullitems){
                       let fieldId = notnullitem.ELMT_ID;
                       let fieldName = notnullitem.ELMT_NAME;
                       if(notnullitemsStr.indexOf(';'+fieldId+'|'+fieldName+';')==-1){
                        notnullitemsStr += fieldId+"|"+fieldName+";";
                       }
                    }
                    // this.process.notnullitems=notnullitemsStr;
                    this.$nextTick(() => {
                      this.process.notnullitems=notnullitemsStr;
                      console.log('this.process.notnullitems===',this.process.notnullitems);
                    });

                   }

                  //设置下一办理人
                  this.setNextUserList(data);

                  if(this.t_advice===''){
                    if(this.nextpathtype==='2'){
                      this.t_advice = this.$t('flow_process.defaultadvice_disagree');
                    }else{
                      this.t_advice = this.$t('flow_process.defaultadvice_agree');
                    }
                  }
                }
                this.loading = false;
            });

            //后台返回的表单验证规则
            // var rulesData={applyuser: [{ required: true, message: '请选择用户', trigger: '' }]}
            //新验证规则
            //变更下一步骤时，改变验证规则
            console.log('detailFlow.vue[改变下一步骤]——[this.process] :',this.process);
            // this.$parent.rules=rulesData
            // this.$parent.changeRules(rulesData);

            this.loading = false;

        },
        //保存或者提交成功后秒后进入跳转页面
        threeGo(){
            const TIME_COUNT = 3;
            if(!this.timer){
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(()=>{
                if(this.count > 1 && this.count <= TIME_COUNT){
                    this.count--;
                }else{
                    this.show = true;
                    clearInterval(this.timer);
                    this.timer = null;
                    //重新刷新页面
                    this.reloadparent();
                }
                },1000);
                }
        },
        //重新加载页面
        // reloadBill(){
        //      this.dialogVisible =false;
        //     //跳转的页面写在此处
        //     // this.$router.push({
        //     //     path: this.parentpath,
        //     //     query: this.params

        //     // });
        //     //暂时先强制刷新下
        //     //location.reload();
        //   // window.opener=null;
        //   // window.close();
        //   // window.opener.onSubmit();
        //   //  this.say();
        // },
        /**
         * 刷新父窗口
         */
        reloadparent(){
            this.dialogVisible =false;
            window.close();
            if(this.portalflag !='portal'){
                window.opener.location.reload();
            }
        },
        /**
         * 设置下一办理人
         */
        setNextUserList(data){
            console.log(data);
            //先清空下一办理人
            this.nextuser = '';
            this.nextusers = [];
            this.choosetype= data.data.nextUserList.choosetype;
            this.trantype = data.data.nextUserList.trantype;
            this.nextuserList = data.data.nextUserList.nextuserlist;

            //获取默认下一办理人
            for(let nextuser of this.nextuserList){
                var usercheckflag = nextuser.selectflag;
                // console.log('usercheckflag='+usercheckflag);
                if(usercheckflag == '1' && !(this.trantype ==='03' && this.choosetype==='2')){
                    this.nextuser = nextuser.value;
                    this.nextusers.push(nextuser.value);
                    break;
                }else if(this.choosetype==='2' && this.trantype ==='03'){
                    // this.nextuser = nextuser.value;
                    this.nextusers.push(nextuser.value);
                }
            }
            if(this.choosetype==='2' && this.trantype ==='03'){
              this.nextuser = this.nextusers.join(';');
            }

        },
        buildForms() {
            let aForm = [];
            let sMainFormName = this.validFormInfo.mainFormName;
            if (sMainFormName) {
                aForm.push(
                new Promise((resolve, reject) => {
                    this.$parent.$refs[sMainFormName].validate(valid => {
                    if (valid) {
                        resolve();
                    } else {
                        reject();
                    }
                    });
                })
                );
            }

            let aChildComponentName = this.validFormInfo.childComponentName;
            if (aChildComponentName) {
                for (let currChildComponentName of aChildComponentName) {
                if (!currChildComponentName) {
                    continue;
                }
                aForm.push(
                    new Promise((resolve, reject) => {
                    this.$parent.$refs[currChildComponentName].$refs[
                        "ruleForm"
                    ].validate(valid => {
                        if (valid) {
                        resolve();
                        } else {
                        reject();
                        }
                    });
                    })
                );
                }
            }

            return aForm;
        },
        /**
         * 回调函数
         */
        updateNextHandler(params){

            if(this.isNotNullOrEmpty(params.returnData)){
              let newhandler = '';
              let chnewhandler = '';
              let newhandlerArr = [];
              let chnewhandlerArr = [];
              params.returnData.forEach((val,index,val_arr)=>{
                   // console.log(val);
                   // newhandler += val.userid+'/'+val.deptid;
                   if(val.userid!='' && val.userid!= undefined){
                    newhandlerArr.push(val.userid+'/'+val.deptid);
                    chnewhandlerArr.push(val.username+'/'+val.deptname);
                   }

             });
             newhandler = newhandlerArr.join(";");
             chnewhandler = chnewhandlerArr.join(";");
             this.$set(this.setflowform, "newhandler", newhandler);
             this.$set(this.setflowform, "chnewhandler", chnewhandler);

            }
        },
        /**
         * 回调函数
         */
        updateReader(params){
            if(this.isNotNullOrEmpty(params.returnData)){
              let readerids = '';
              let readernames = '';
              let readeridArr = [];
              let readernameArr = [];
              params.returnData.forEach((val,index,val_arr)=>{
                   if(val.userid!='' && val.userid!= undefined){
                    readeridArr.push(val.userid+'/'+val.deptid);
                    readernameArr.push(val.username+'/'+val.deptname);
                   }
             });
             readerids = readeridArr.join(";");
             readernames = readernameArr.join(";");
             this.$set(this, "reader", readerids);
             this.$set(this, "readername", readernames);

            }
        },
        /**
         * 回调函数
         */
        updateNextUser(params){
            if(this.isNotNullOrEmpty(params.returnData)){
              let nextuserids = '';
              let nextusernames = '';
              let nextuseridArr = [];
              let nextusernameArr = [];
              params.returnData.forEach((val,index,val_arr)=>{
                   if(val.userid!='' && val.userid!= undefined){
                    nextuseridArr.push(val.userid+'/'+val.deptid);
                    nextusernameArr.push(val.username+'/'+val.deptname);
                   }
             });
             nextuserids = nextuseridArr.join(";");
             nextusernames = nextusernameArr.join(";");
             this.$set(this, "nextusers", nextuserids);
             this.$set(this, "nextusernames", nextusernames);

            }
        },
        // 重新提取待办
        async syncTasksByApplyId(){
          startLoading(this.$t('flow_process.submitting'));
          this.isDisabled = true;
          this.$nextTick(() => {
          Promise.all(this.buildForms())
          .then(async () => {
              let params = {
                processid: this.process.processid,
                flow_keyval: this.process.flow_keyval,
                flow_btype: this.process.flow_btype,
                applyareacode: this.process.applyareacode
              };
              //进行提交操作
              // console.info(params);
              await axios.post('/flowProcess/syncTasksByApplyId', params).then(({ data }) => {
              var code = data.code;
              // console.info("=========" + JSON.stringify(data));
              // console.info(code);
              if (code != "1") {
                  //返回失败
                  this.returnflag = false;
              } else {
                 //弹出提示框 进行倒计时
                 this.tipSuccess(this.$t('flow_process.tip_syncTaskSucc'));
                 this.reloadbill();
              }
              });

              this.isDisabled = false;
              endLoading();

              //关闭流程帧
              this.dialogsetflowVisible = false;

              if(this.portalflag !='portal'){
                  //刷新父窗口
                  window.opener.location.reload();
              }

          })
          .catch(error => {

              console.log("error",error);
              this.isDisabled = false;
              endLoading();

          });
        });

        },
        // 停止流程实例
        stopProcess(){

        },
        // 调整流程实例
        chgCurrFlowStatus(){

            startLoading(this.$t('flow_process.submitting'));
            this.isDisabled = true;
            this.$nextTick(() => {
            Promise.all(this.buildForms())
            .then(async () => {
                let params = {
                  newhandler: this.setflowform.newhandler,
                  chnewhandler: this.setflowform.chnewhandler,
                  newflowcode: this.setflowform.newFlowCode,
                  flow_keyval: this.process.flow_keyval,
                  flow_btype: this.process.flow_btype,
                  applyareacode: this.process.applyareacode,
                  orderno: this.setflowform.orderno,
                  notion: this.setflowform.notion
                };
                //进行提交操作
                // console.info(params);
                await axios.post('/flowProcess/syncJump', params).then(({ data }) => {
                var code = data.code;
                console.info("=========" + JSON.stringify(data));
                console.info(code);
                if (code != "1") {
                    //返回失败
                    this.returnflag = false;
                } else {
                   //弹出提示框 进行倒计时
                   this.tipSuccess(this.$t('flow_process.tip_chgCurrFlowSucc'));
                   this.reloadbill();
                }
                });

                this.isDisabled = false;
                endLoading();

                //关闭流程帧
                this.dialogsetflowVisible = false;

                if(this.portalflag !='portal'){
                    //刷新父窗口
                    window.opener.location.reload();
                }

            })
            .catch(error => {

                console.log("error",error);
                this.isDisabled = false;
                endLoading();

            });
          });

        },
        checkAdvice(){//验证办理意见是否必填
            let notNullItem= this.process.notnullitems;
            if(notNullItem.indexOf("FLOW_PROCESS_ADVICE|")>-1){
                let elemName = this.$t('flow_process.advice');
                if(!this.checkFormElment(this.t_advice,this.formatMsg(this.$t('flow_process.errormsg'), [elemName]))){
                   return false;
                }
            }
            return true;
        },
        async openSyncCurrFlowPop(taskId){
          let processid = '';
          let params = {
            flow_taskid: taskId
          };
          await axios.post('/flowProcess/getSyncCurrFlowFlag',params).then(({data})=>{
             var code = data.code;
              if(code === '1'){
                 processid = data.data.synccurrflowflag;
              }
          });

          if(processid != ''){
             this.$alert('Network abnormalities! Please click the "Re-extract To-Do" button.', '', {
                   confirmButtonText: 'Re-extract To-Do',
                   showClose: false,
                   callback: action => {

                     let params = {
                       processid: processid,
                       flow_keyval: this.process.flow_keyval,
                       flow_btype: this.process.flow_btype,
                       applyareacode: this.process.applyareacode
                     };
                     //进行提交操作
                     // console.info(params);
                     axios.post('/flowProcess/syncTasksByApplyId', params).then(({ data }) => {
                       var code = data.code;
                       // console.info("=========" + JSON.stringify(data));
                       // console.info(code);
                       if (code != "1") {
                           //返回失败
                           this.returnflag = false;
                       } else {
                          //弹出提示框 进行倒计时
                          this.tipSuccess(this.$t('flow_process.tip_syncTaskSucc'));
                          location.reload();
                       }
                     });

                     // if(this.portalflag !='portal'){
                     //     //刷新父窗口
                     //     window.opener.location.reload();
                     // }

                   },
                   });
          }
        }
     },
     /**
      * 初始化
      */
     created(){
         this.rulesList = this.flowrules;
         // console.info("===初始化流程");
         //openflag=portal
         this.portalflag = this.$route.query['openflag']
     },
     mounted(){
         // console.info("XXXXXXXX流程帧初始化")

         let flow_taskid = this.$route.query.flow_taskid;
         if(flow_taskid != '' && flow_taskid != undefined){
          this.process.flow_taskid = flow_taskid;
         }

         if(flow_taskid != undefined){
          this.openSyncCurrFlowPop(flow_taskid);
         }

     },
     computed: {
        processOperBtnList: function () {
          if(this.isNotNullOrEmpty(this.process.operBtnList)){
            for(let btn of this.process.operBtnList){
              if(btn.opertype=='delete'){
                btn.operbtn=this.$t('common.delbut');
              }
              if(btn.opertype=='getFlowAdvice'){
                btn.operbtn='Flow/Advice Approval'
              }
            }
          }

          return this.process.operBtnList;
        }
      }
}



// WEBPACK FOOTER //
// ./src/pccomponents/detailFlow.vue